/**
 * Converts character references in a string to their corresponding characters.
 * Supported references include named entities (&amp;, &lt;, &gt;, &quot;, &apos;)
 * and decimal (&#65;) or hexadecimal (&#x41;) numeric character references.
 * If a character reference is not recognized or invalid, it is left unchanged.
 *
 * @param input - The input string containing character references.
 * @returns The string with character references converted to their corresponding characters.
 */
function convertCharRefs(input: string): string {
    const charRefRegex = /&(amp|lt|gt|quot|apos|#(?:x[\da-fA-F]+|\d+));/g;

    return input.replace(charRefRegex, (match, entity) => {
        if (entity.charAt(0) === "#") {
            const code =
                entity.charAt(1) === "x"
                    ? parseInt(entity.substr(2), 16)
                    : parseInt(entity.substr(1), 10);
            if (!isNaN(code)) {
                return String.fromCharCode(code);
            }
        } else {
            const charRefMap: Record<string, string> = {
                amp: "&",
                lt: "<",
                gt: ">",
                quot: '"',
                apos: "'",
            };
            if (entity in charRefMap) {
                return charRefMap[entity];
            }
        }
        return match; // return the original match if no conversion found
    });
}

export default convertCharRefs;
